import MobilPaidDetail from "./styles";

export default MobilPaidDetail;
